/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { BuilderUserContext } from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { DictionaryItem } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { NotificationService } from '@gh/core-ui';
import { Observable } from 'rxjs';

import { LeadBoardColumnId, LeadBoardListItem } from '../../../../resources/lead-board.model';
import { LeadBoardCommandService } from '../../lead-board-command.service';
import { LeadBoardFormState } from '../../lead-board-form.service';
import { getLeadBoardItemId } from '../../lead-board.state';

@Component({
  standalone: false,
  selector: 'gh-lead-board-column',
  templateUrl: 'lead-board-column.component.html',
  styleUrls: ['lead-board-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadBoardColumnComponent implements OnInit {

  @Input() priority: DictionaryItem<any>;
  @Input() stage: DictionaryItem<any>;
  @HostBinding('class.m-is-drop-active')
  @Input() dropActive: boolean;

  compoundId: LeadBoardColumnId;

  cardList$: Observable<LeadBoardListItem[]>;
  // we have to provided dragging card to the ghVirtualList,
  // because we should not remove it from the DOM:
  // on touch devices DOM element catching touchstart event should not be removed until touch gesture is completed,
  // otherwise touchmove and touchend events will not be propagated to the document
  draggingCard$: Observable<Maybe<LeadBoardListItem>>;
  openedCard$: Observable<Maybe<LeadBoardListItem>>;
  isDragEnabled: boolean;

  constructor(public form: LeadBoardFormState,
              private notificationService: NotificationService,
              private userContext: BuilderUserContext,
              private commandService: LeadBoardCommandService) {
  }

  ngOnInit(): void {
    this.compoundId = { priority: this.priority.id, stage: this.stage.id };
    this.cardList$ = this.form.cardsFor$(this.priority.id, this.stage.id);
    this.draggingCard$ = this.form.draggingCardFor$(this.priority.id, this.stage.id);
    this.isDragEnabled = this.userContext.hasPermission(BuilderPermission.Sales.Leads.EDIT);
    this.openedCard$ = this.form.openedCardFor$(this.priority.id, this.stage.id);
  }

  toggleCard(id: ID): void {
    this.commandService.toggleCard(id);
  }

  getCardId(index: number, item: LeadBoardListItem): ID {
    return getLeadBoardItemId(item);
  }
}
